// Vendors
import { deviceUtils, sessionUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { CANCEL_URL_CALLED_CUSTOM_ACTION } from './constants/callback-back.handlers.constants';
import { REDIRECTION_FORCED } from 'constants/app.constants';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import {
  CallbackBackBuilderHandlersType,
  CallbackBackMethodsHandlersType,
} from './types/callback-back.handlers.type';
// Utilities
import { getCallbackLoanUrl, navigateToCallbackUrl } from 'utils/app-callback-url.utils';
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';
import { getAppDomain } from 'utils/domain.utils';

const sendCustomActionEventHandler = async ({
  handleSendCustomActionEvent,
  resetBoundary,
  setCurrentState,
  ...props
}: CallbackBackBuilderHandlersType): Promise<void> => {
  if (deviceUtils.isMobileDevice()) {
    setCurrentState?.(AppStatesEnumeration.PROCESS_ENDED);
    resetBoundary?.();
  }
  try {
    await handleSendCustomActionEvent(CANCEL_URL_CALLED_CUSTOM_ACTION + getCallbackLoanUrl(props));
    sessionUtils.clearSessionData(getAppDomain());
    sessionStorage.setItem(REDIRECTION_FORCED, getCheckoutIdFromUrl());
    navigateToCallbackUrl(props);
  } catch (e) {
    window.close();
  }
};

const CallbackBackHandlers = (
  props: CallbackBackBuilderHandlersType
): CallbackBackMethodsHandlersType => ({
  handleLogCallbackUrlCallEvent: () => sendCustomActionEventHandler(props),
});

export { CallbackBackHandlers };
